import { LinkProps } from './LinkScreen';
import * as React from 'react';
import { FlowLinkAction } from '../../model/Action';
import { MachineContext } from '../fsm/useMachine';
import guidGenerator from '../utils/commonFunctions';


export const FlowLink: React.FC<LinkProps<FlowLinkAction>> = ({ set_action, existing }) => {
    const [, send] = React.useContext(MachineContext)
    const strId = React.useRef(null)
    const index = React.useRef(null)
    const [stringId, setStringId] = React.useState("")
    const [indexVal, setIndexVal] = React.useState(1)

    const formAction = (e: React.ChangeEvent<HTMLInputElement>) => {
        send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
        // @ts-ignore
        const currStr = strId.current!.value
        //@ts-ignore
        const currIdx = parseInt(index.current!.value) || 1
        setStringId(currStr)
        setIndexVal(currIdx)

        const action = new FlowLinkAction(currStr, currIdx)
        set_action({ __tag: "flow", value: action })
    }

    React.useEffect(() => {
        if (existing != undefined) {
            setStringId(existing.__stringId)
            setIndexVal(existing.__index)
        }
    }, [])

    return (
        <React.Fragment>
            <div className="linkMenu-desc">
                <h3>Set Flow Link</h3>
                <p>
                    When viewer clicks this object, they will launch the specified Flow to
                    the given screen
        </p>
            </div>
            <div className="flex">
                <div className="flex_column" >
                    <b>String ID:</b>
                    <input
                        type="text"
                        placeholder="String ID"
                        defaultValue={existing?.__stringId}
                        ref={strId}
                        onChange={formAction}
                        id={guidGenerator()}
                        className="linkInput"
                    />
                </div>
                <div className="flex_column">
                    <b>Screen Number:</b>
                    <input
                        type="text"
                        pattern={"[+-]?([0-9]*[.])?[0-9]+"}
                        placeholder="Screen Index"
                        defaultValue={String(existing?.__index || "1")}
                        ref={index}
                        onChange={formAction}
                        className="linkInput"
                    />
                </div>
            </div>
        </React.Fragment>
    )
}